var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#A5A5A5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M793 4543 c-36 -7 -79 -57 -86 -100 -4 -21 -7 -165 -7 -320 l0 -282 -308 -3 c-278 -3 -311 -5 -336 -21 -59 -39 -56 53 -54 -1626 l3 -1540 21 -28 c11 -15 38 -34 59 -41 29 -10 471 -12 2144 -10 1943 3 2108 4 2129 20 57 40 57 38 60 375 l3 312 308 3 c277 3 310 5 335 21 59 39 56 -53 54 1626 l-3 1540 -21 28 c-11 15 -36 33 -55 40 -26 9 -530 12 -2129 11 -1152 0 -2105 -3 -2117 -5z m4007 -1628 l0 -1315 -1890 0 -1890 0 0 1315 0 1315 1890 0 1890 0 0 -1315z m-4100 -321 c0 -780 -2 -935 -15 -983 -29 -112 -62 -307 -80 -473 l-6 -58 1606 0 1607 0 -6 23 c-3 12 -17 57 -30 100 l-24 77 174 0 174 0 0 -195 0 -195 -1890 0 -1890 0 0 1315 0 1315 190 0 190 0 0 -926z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3707 4029 c-62 -15 -137 -58 -189 -110 -149 -149 -149 -399 0 -548 195 -195 516 -140 636 109 28 59 31 74 31 165 0 91 -3 106 -31 165 -34 72 -105 150 -165 180 -85 44 -196 59 -282 39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2062 3531 c-177 -66 -354 -300 -497 -656 -129 -320 -229 -721 -251 -997 l-7 -88 1606 0 c1281 0 1606 3 1602 13 -79 253 -133 393 -216 559 -111 222 -215 346 -322 386 -68 26 -81 27 -135 8 -56 -20 -129 -68 -247 -163 -233 -187 -326 -197 -461 -50 -71 78 -194 241 -353 467 -233 330 -334 441 -457 501 -84 42 -183 49 -262 20z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon-image.6d2b177784ca86e422b97682b1b6db0c.svg";
export { ForwardRef as ReactComponent };